import { z } from 'zod';
import { FormFieldType } from './FormValues';

const FormFieldConstraintDTO = z.object({
    isRequired: z.boolean(),
    maxLength: z.number().optional(),
});

export const BaseFormFieldDTO = z
    .object({
        id: z.string(),
        type: z.enum([FormFieldType.TEXT, FormFieldType.NUMBER, FormFieldType.BOOLEAN]),
        defaultValue: z.string().optional(),
    })
    .merge(FormFieldConstraintDTO);

const FormFieldSelectOptionDTO = z.object({
    value: z.string(),
    label: z.string(),
    selected: z.boolean().optional(),
});

export const SelectFormFieldDTO = BaseFormFieldDTO.extend({
    type: z.literal(FormFieldType.SELECT),
    options: z.array(FormFieldSelectOptionDTO),
});

export const FormFieldDTO = z.discriminatedUnion('type', [BaseFormFieldDTO, SelectFormFieldDTO]);

export type FormFieldSelectOptionDTO = z.infer<typeof FormFieldSelectOptionDTO>;
export type SelectFormFieldDTO = z.infer<typeof SelectFormFieldDTO>;
export type FormFieldDTO = z.infer<typeof FormFieldDTO>;
